import React, { useContext, useState, FormEvent } from 'react';
import { Tab, Button, Table, Label, Form,  Segment, Dimmer, Icon } from 'semantic-ui-react';
import ProjectStore from '../../../app/stores/projectStore';
import * as XLSX from 'xlsx'
import { observer } from 'mobx-react-lite';
import { IWarehouseLog } from '../../../app/models/warehouselog';
import { RootStoreContext } from '../../../app/stores/rootStore';
import WarehouseImportForm from './WarehouseImportForm';

const WarehouseTab = () => {
  const rootStore = useContext(RootStoreContext);
  const { openModal } = rootStore.modalStore;
  const projectStore = useContext(ProjectStore);
  const {
    projectsByDate: projectsByDate,
    projecttasksByName: projecttasksByName,
    project,
    selectedProjectTask,
    deleteProject: deleteProject,
    loadProjectTasks: loadProjectTasks,
    loadWarehouseLogs,
    techniciansByName,
    loadProjectStocks,
    createWarehouseLog,
    deleteWarehouseLog,
    importWarehouseLogs,
    technicianRegistry,
    warehouselogsByDate,
    warehouseOut,
    projectstocksByName,
    technicianEmail,
    warehousesByPartNo,
    submitting,
    editMode,
    target } = projectStore;

  const initializeForm: IWarehouseLog = {
    id: '0',
    createdAt: '',
    updatedAt: '',
    projectId: project!.id,
    orderNo: '',
    partNo: '',
    name:'',
    uom: '',
    quantity: 0,
    stock: 0,
    status: '',
    pickedBy: '',
    assignedTo: '',
    url: '',
    remark: ''
  };


  const [warehouselog, setWarehouseLog] = useState<IWarehouseLog>
    ({
      id: '0',
      createdAt: '',
      updatedAt: '',
      projectId: project!.id,
      orderNo: '',
      partNo: '',
      name: '',
      uom: '',
      quantity: 0,
      stock: 0,
      status: '',
      pickedBy: '',
      assignedTo: '',
      url: '',
      remark: ''
    });

  const technicianOptions = techniciansByName.map(function (tech) {
    var option = { "key": tech.name, "text": tech.name, "value": tech.email }
    return option;
  }
  );

  const warehouseOptions = warehousesByPartNo.map(function (warehouse) {
    var option = { "key": warehouse.partNo, "text": warehouse.partNo, "value": warehouse.partNo }
    return option;
  }
  );

  const handleSubmit = (status: string) => {
    if (status === 'inbound') {
      // if (warehouselog.pickedBy) {
      //   const selectEmail = technicianRegistry.get(warehouselog.pickedBy);
      //   warehouselog.pickedBy = selectEmail.email;
      // }
      warehouselog.status = status;
      let warehouselogs: IWarehouseLog[] = new Array();
      warehouselogs.push(warehouselog);
      !addMode && warehouselog.partNo && createWarehouseLog(warehouselogs).then(
        () => loadWarehouseLogs(warehouselog.projectId)).then(
          () => loadProjectStocks(warehouselog.projectId)).then(
            () => initializeForm && setWarehouseLog(initializeForm)
          );

    }
    else if (status === 'outbound') {
      projectstocksByName.map(log => {
        if (log.quantity > 0) {
          const logoutbound: IWarehouseLog = {
            id: '0',
            createdAt: '',
            updatedAt: '',
            projectId: log.projectId,
            orderNo: '',
            partNo: log.partNo,
            name: '',
            uom: '',
            quantity: log.quantity,
            stock: 0,
            status: status,
            pickedBy: '',
            assignedTo: log.assignedTo,
            url: '',
            remark: log.remark
          };
          let warehouselogs: IWarehouseLog[] = new Array();
          warehouselogs.push(logoutbound);
          createWarehouseLog(warehouselogs).then(() => loadWarehouseLogs(log.projectId)).then(() => loadProjectStocks(log.projectId));
        }
      });
    }
  };

  const [addMode, setAddMode] = useState(false);

  const [active, setDimmer] = useState({
    rowid: '',
    status: false
  });

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setWarehouseLog({ ...warehouselog, [name]: value });
  };

  const readExcel = (file: FileList | null) => {
    let fileName = file![0].name;
    let orderNo = fileName.substring(
      fileName.lastIndexOf("-") + 1, 
      fileName.lastIndexOf(".")
  );
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsBinaryString(file![0]);

      fileReader.onload = () => {
        // const bufferArray = e.target!.result;
        const bufferArray = fileReader.result;
        const wb = XLSX.read(bufferArray, { type: 'binary' });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws);

        resolve(data);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });

    promise.then((d) => {
      console.log(d);
      importWarehouseLogs(d, project!.id, orderNo).then(() => openModal(<WarehouseImportForm projectId={project!.id} />))
    }).catch((error) => console.log(error));
  }

  return (
    <Tab.Pane clearing>

      <Segment clearing>
        <Form onSubmit={(e) => handleSubmit('inbound')} >
          {addMode &&
            <Form.Group>
              <Form.Input
                label='Order No'
                required
                onChange={handleInputChange}
                name='orderNo'
                placeholder='Order No'
                value={warehouselog.orderNo}
              />
              <Form.Select
                required
                label='Part No'
                onChange={(e, { name, value }) => setWarehouseLog({ ...warehouselog, [name]: value })}
                options={warehouseOptions}
                search
                name='partNo'
                placeholder='Part No'
                value={warehouselog.partNo}
              />
              <Form.Input
                label='Quantity'
                onChange={handleInputChange}
                name='quantity'
                placeholder='Quantity'
                value={warehouselog.quantity}
              />
              <Form.Select
                label='Picked By'
                onChange={(e, { name, value }) => setWarehouseLog({ ...warehouselog, [name]: value })}
                options={technicianOptions}
                search
                name='pickedBy'
                placeholder='Name'
                value={warehouselog.pickedBy}
              />
              <Form.Input
                label='Remark'
                onChange={handleInputChange}
                name='remark'
                placeholder='Remark'
                value={warehouselog.remark}
              />
            </Form.Group>
          }
          <Button
            loading={submitting}
            floated='right'
            positive
            type='submit'
            content={addMode ? 'Submit' : 'Add'}
            onClick={() => setAddMode(!addMode)}
          />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <Button as="label" htmlFor="file" type="button" color='grey' size='small'>
            <Icon name='file excel' />
               Import
             </Button>
          <input type="file" id="file" accept='.xlsx, .xls, .csv' hidden
            onChange={(e) => {
              const file = e.target.files;
              readExcel(file);
            }} />
        </Form>
      </Segment>

      <Form onSubmit={(e) => handleSubmit('outbound')}>
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell >Part No</Table.HeaderCell>
              <Table.HeaderCell >Stock</Table.HeaderCell>
              <Table.HeaderCell >Assigned To</Table.HeaderCell>
              <Table.HeaderCell >Quantity</Table.HeaderCell>
              <Table.HeaderCell >Remark</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {projectstocksByName.map(projectstock => (

              <Table.Row key={projectstock.partNo}>
                <Table.Cell>
                  <Label>{projectstock.partNo}</Label>
                </Table.Cell>
                <Table.Cell>{projectstock.stock}</Table.Cell>
                <Table.Cell>

                  <Form.Select
                    required
                    onChange={(e, { name, value }) => warehouseOut(e, projectstock, name, '')}
                    options={technicianOptions}
                    search
                    name='assignedTo'
                    placeholder='Name'
                    value={projectstock.assignedTo}
                  />

                </Table.Cell>
                <Table.Cell>
                  <Form.Input
                    name='quantity'
                    value={projectstock.quantity}
                    onChange={(e, { name, value }) => warehouseOut(e, projectstock, name, value)}
                  //  onChange={(e, { name, value }) => updateMember(e, tasktechnician, name, value)}
                  />
                </Table.Cell>
                <Table.Cell>
                  <Form.Input
                    name='remark'
                    value={projectstock.remark}
                    onChange={(e, { name, value }) => warehouseOut(e, projectstock, name, value)}
                  //  onChange={(e, { name, value }) => updateMember(e, tasktechnician, name, value)}
                  />
                </Table.Cell>
                {/* <Table.Cell>
                <Button.Group size='mini'>
                  <Button
                  // onClick={() => selectProjectTask(projecttask.id)}
                    size='mini'
                    content='Check-Out'
                    color='blue'
                  />
                </Button.Group>
              </Table.Cell> */}
              </Table.Row>
            ))}
          </Table.Body>

        </Table>
        <Button loading={submitting} floated='right' positive type='submit' content='Submit' />
      </Form>
      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={3}>Date</Table.HeaderCell>
            <Table.HeaderCell>Status</Table.HeaderCell>
            <Table.HeaderCell>Order No</Table.HeaderCell>
            <Table.HeaderCell>Part No</Table.HeaderCell>
            <Table.HeaderCell>Quantity</Table.HeaderCell>
            <Table.HeaderCell>Picked By</Table.HeaderCell>
            <Table.HeaderCell>Assigned To</Table.HeaderCell>
            <Table.HeaderCell>Remark</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {warehouselogsByDate.map(warehouselog => (
            <Table.Row key={warehouselog.id}>
              <Dimmer.Dimmable
                dimmed
                onMouseEnter={() => setDimmer({ ['rowid']: warehouselog.id, ['status']: true })}
                onMouseLeave={() => setDimmer({ ['rowid']: warehouselog.id, ['status']: false })}
              >
                <Table.Cell>
                  <Label>{warehouselog.createdAt.substr(0, 19)}</Label>
                </Table.Cell>
                <Dimmer
                  active={(active.rowid === warehouselog.id) && active.status}
                >
                  <Button
                    name={warehouselog.id}
                    size='mini'
                    // loading={target === projectlog.id && submitting}
                    onClick={(e) => deleteWarehouseLog(e, warehouselog.id).then(() => loadWarehouseLogs(warehouselog.projectId)).then(() => loadProjectStocks(warehouselog.projectId))}
                    content='Delete'
                    color='red'
                  />
                </Dimmer>
              </Dimmer.Dimmable>
              <Table.Cell>{warehouselog.status}</Table.Cell>
              <Table.Cell>{warehouselog.orderNo}</Table.Cell>
              <Table.Cell>{warehouselog.partNo}</Table.Cell>
              <Table.Cell>{warehouselog.quantity}</Table.Cell>
              <Table.Cell>{technicianEmail.get(warehouselog.pickedBy)}</Table.Cell>
              <Table.Cell>{technicianEmail.get(warehouselog.assignedTo)}</Table.Cell>
              <Table.Cell>{warehouselog.remark}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
      
    </Tab.Pane>
  );
};

export default observer(WarehouseTab);
